import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAutocompleteDirective } from './directive/google-autocomplete.directive';
import { LocationSearchComponent } from './location-search/location-search.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { SharedDirectiveModule } from '@railmybox/shared/directive';
import { InputModule, SelectModule, ButtonModule, TooltipModule } from '@eg/ui';

@NgModule({
  declarations: [GoogleAutocompleteDirective, LocationSearchComponent],
  imports: [CommonModule, SelectModule, FlexLayoutModule, InputModule, TranslocoModule, SharedDirectiveModule, ButtonModule, TooltipModule],
  exports: [GoogleAutocompleteDirective, LocationSearchComponent],
})
export class AddressModule {}
